<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
};
</script>

<style lang="scss">
* {
  margin: 0px;
  padding: 0px;
  /* overflow: hidden; */
}
#app {
  height: 100vh;
  width: 100%;
  background-color: #f9fafd;
}

/* 美化滚动条样式 */
::-webkit-scrollbar {
  width: 6px; /* 滚动条宽度 */
  height: 6px; /* 横向滚动条高度 */
}

::-webkit-scrollbar-track {
  background: transparent; /* 滚动条轨道背景 */
  border-radius: 3px;
}

::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.1); /* 滚动条颜色 */
  border-radius: 3px; /* 圆角 */
}

::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 0, 0, 0.2); /* 鼠标悬停时的颜色 */
}

/* Firefox 滚动条样式 */
html {
  scrollbar-width: thin; /* 'auto'、'thin' 或 'none' */
  scrollbar-color: rgba(0, 0, 0, 0.1) transparent; /* 滑块颜色 轨道颜色 */
}
</style>
